import {useCallback} from "react";
import LoginService from "../services/web/login-service.js";
import {queryClient} from "../services/query-client.js";
import {redirectToLogin} from "../services/http.js";

const useLogout = () => useCallback(async () => {
    await LoginService.logout().catch(() => null);

    queryClient.clear();
    redirectToLogin();
}, []);

export default useLogout;
